import { render } from "./HomeHeader.vue?vue&type=template&id=40c12336"
const script = {}

import exportComponent from "F:\\codecanyon-work\\demo-page\\NAC-Portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__